<template>
    <Modal :fadeOff="false" @opened="opened($event)" @closed="closeModal()" :size="'fs'" :modalId="modalId">
        <template #body>
            <div class="modal-body-scrollable">
                <i class="fa-solid fa-cards-blank"></i>
                <img id="nfcImg" class="center" src="..//..//..//public//img//icons//nfccard.svg" alt="">
                <p class="center scanText" v-if="!nfcId && selectedUser">{{ $t('admin.users.NFC.scanNFCTag') }}
                    {{ selectedUser.displayName }}</p>
                <p class="center scanText" v-else>{{ nfcId }}</p>
                <div v-if="scanResponse.error">
                    <p class="center scanTextResponse">{{ scanResponse.error }}</p>
                    <p class="center scanTextResponse">{{ scanResponse.message }}</p>
                </div>
            </div>
        </template>
        <template #footer>
            <Button class="w-100 h-2 mb-2 mt-2" :color="getColors.defaultColorSolidButton"
                @frameworkButtonClicked="handleNfcScan()" :backgroundColor="getColors.defaultBackgroundColorSolidButton"
                :outline="true" :size="'small'" :display="'inline'" :width="'calc(100% - 5px)'" :padding="'2px 0'">
                <template #button-content>
                    <span>{{ $t('ifttt.save') }} </span>
                </template>
            </Button>
            <Button class="w-100 h-2 mb-2 mt-2" @frameworkButtonClicked="closeModal"
                :color="getColors.defaultColorOutlineButton"
                :backgroundColor="getColors.defaultBackgroundColorOutlineButton" :outline="true" :size="'small'"
                :display="'inline'" :width="'calc(100% - 5px)'" :padding="'2px 0'">
                <template #button-content>
                    <span>{{ $t('ui.cancel') }}</span>
                </template>
            </Button>
        </template>
    </Modal>
</template>

<script>
import colors from "@/assets/scss/MotivateColors.scss";
import Button from "@/components/ui/Button.vue";
import Modal from '@/components/ui/Modal.vue';

import axios from 'axios';
import {hashWithCrypto} from "@/util/hashing";

export default {
    name: "nfcModal",
    components: { Modal, Button },
    mixins: [],
    props: ['modalId', 'user'],
    data() { 
        return {
            nfcId: null,
            scanResponse: {
                error: null,
                message: null
            },
            selectedUser: null,
            showModal: false
        }
    },
    computed: {
        getColors() {
            return colors
        },
      getUser() {
        return this.user
      },
    },
    methods: {
        closeModal() {
            this.showModal = false
            this.nfcId = null
                this.scanResponse = {
                    error: null,
                    message: null
                }
            this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
            window.$('#' + this.modalId).modal('hide')
            $('.modal-backdrop').remove()
        },
        async opened(event) {
            this.showModal = true
            this.$barcodeScanner.barCodeEventBus.$on('barcodeScanned', this.barcodeScanned);
        },
        async handleNfcScan(tag) {
            let response = await this.checkIdAvailability(tag)
            if (response.available) {
                await this.saveNfcId();
                this.swalToastSuccess(this.$t("ui.save"));
                this.nfcModalOpen = false
                this.closeModal()
            } else {

                if (!response.available) {
                    this.scanResponse = {
                        error: "ID tag is unavailable",
                        message: "The chosen ID is already in use by the platform"
                    }

                }
            }
        },
        async saveNfcId() {
          let nfcId = this.nfcId
          this.selectedUser.nfcId = await hashWithCrypto(nfcId)
          
          const isAvailable = this.checkIdAvailability(this.selectedUser.nfcId)
          this.$FUNCTIONS.Users('updateUser', { user: this.selectedUser, claims: this.claims }).then(function (result) {
            self.swalToastSuccess('NFC opgeslagen');
            self.$store.commit('setLoading', false);
          }).catch(e => {
            this.swalError(e.message);
            self.$store.commit('setLoading', false);
          })
            this.nfcId = null
            this.selectedUser.nfcId = nfcId
            return

        },
        async barcodeScanned(tag) {
            this.nfcId = tag
            await this.handleNfcScan(tag)

        },
        async checkIdAvailability(tag) {
            try {
                const { data: available } = await axios.post(process.env.VUE_APP_CLOUD_HTTP_API + '/authentication/checkNfcTagAvailability', {
                    tag: await hashWithCrypto(tag)
                })
                // available moet op response worden gezet
                return available
            } catch (e) {
                console.log(e)
            }
        },

    },
    watch: {
      getUser: {
        handler(newVal) {
          this.selectedUser = { ...newVal }
        }
      },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";
@import "../../assets/scss/workflowInterface/form.scss";
#nfcImg {
  width: 15rem;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  text-align: center;
}

.scanText {
  margin-top: 5%;
  font-weight: bold;
}

.scanTextResponse {
  margin-top: 5%;
  font-weight: bold;
  font-size: 12px;
  width: 80%;
}
</style>